import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styles: [`
  .need-help {
    color: black
}

.need-help a {
  color: black;
  font-weight: bolder;
  text-decoration: none;
}
  .showInDesktop {
    display: block;
  }
  @media (max-width: 700px) {
    .showInDesktop {
      display: none;
    }
  }
  `]
})
export class ShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
